<template>
  <div :class="['dashboard-object-tree', disabled ? 'disabled' : '']">
    <div class="search">
      <w-search-field ref="searchField" size="mini" @search="filterTree"/>
    </div>
    <el-scrollbar class="dashboard-object-tree__wrapper">
      <el-tree class="tree-checkbox"
        :default-expanded-keys="['1']"
        :ref= "TREE_CONST.REF"
        :data="treeData"
        :props="defaultProps"
        :node-key="defaultProps.treeKey"
        :highlight-current="!isMultiple"
        :show-checkbox="isMultiple"
        :filter-node-method="filterNode"
        :expand-on-click-node="false"
        v-on="(isMultiple) ? {'check-change': onCheckChange} : {'node-click': onNodeClick }"
      >
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <label :title="rscNodeLabel(data)">{{rscNodeLabel(data)}}</label>
        </span>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
import WidgetAPI from '@/api/dashboard/widget';
import { defaultProps } from '@/constants/tree';
import DashboardConst from '@/constants/dashboard';
import { isEmpty } from '@/utils/basic';
import { getPathNodes } from '@/utils/tree';
import cloneDeep from 'lodash/cloneDeep';
import WSearchField from '@/components/form/SearchField';

const TREE_CONST = DashboardConst.TREE_CONST;

export default {
  name: 'WRscSelectTree',
  components: {
    WSearchField,
  },
  props: {
    /**
     * [전체선택일 경우 트리 disalble 처리 여부]
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * [트리 타입 : check인지 single인지 ]
     * @type {String}
     */
    isMultiple: {
      type: Boolean,
      default: false,
    },
    isMultipleUnit: {
      type: Boolean,
      default: false,
    },
    /**
     * [트리 기존 설정 노드]
     * @type {Object}
     */
    selecetedNode: {
      type: [Object, Array],
      default: () => {},
    },
    selectScope: {
      type: String,
      default: TREE_CONST.SELECT_SCOPE.DEFAULT,
    },
  },
  data() {
    return {
      TREE_CONST,
      isEmpty,
      defaultProps,
      treeData: [],
      rscData: [],
      selectedNodeunit: '',
      defaultFilterValue: {
        managetypeId: 'SMS',
        managetypeKey: '_',
      },
    };
  },
  computed: {
    treeRef() {
      return this.$refs[TREE_CONST.REF];
    },
  },
  watch: {
    treeData: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val)) {
          this.$nextTick(() => {
            this.treeRef.filter();
          });
        }
      },
    },
  },
  methods: {
    loadData(managetypeInfo) {
      const { managetypeId, managetypeKey, isPredict } = managetypeInfo;

      WidgetAPI.getRscTree(managetypeId, managetypeKey, isPredict).then((rscTreeRes) => {
        this.rscTreeLoading = false;
        this.treeData = rscTreeRes.data.children;
        this.rscData = cloneDeep(rscTreeRes.data.children);
        this.$nextTick(() => {
          this.expandNodeByTreeKey(this.treeKeyList);
          if (this.isMultiple) {
            this.treeRef.setCheckedKeys(this.treeKeyList);
          } else {
            this.treeRef.setCurrentKey(this.treeKeyList[0]);
          }
        });
      });
    },
    rscNodeLabel(data) {
      return this.isRscLeafNode(data) ? `${data.label} (${data.rscUnit || '-'})` : data.label;
    },
    isRscLeafNode(data) {
      return data.leaf;
    },
    filterTree(keyword) {
      if (this.treeRef) {
        this.treeRef.filter(keyword);
      }
    },
    filterNode(value, data) {
      if (isEmpty(value)) return true;
      if (isEmpty(data.rscUnit)) {
        return (data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      }
      // rscUnit 정보가 있는 경우 rscUnit도 함께 검색한다.
      const keyword = value.toLowerCase();
      return (data.label.toLowerCase().indexOf(keyword) !== -1 || (!isEmpty(data.rscUnit) && data.rscUnit.toLowerCase().indexOf(keyword) !== -1));
    },
    initTreeData() {
      this.treeData = [];
      this.initSelectionOrCheck();
    },
    initSelectionOrCheck() {
      if (this.isMultiple) {
        this.treeRef.setCheckedKeys([]);
      } else if (!isEmpty(this.treeRef.getCurrentNode())) {
        this.treeRef.setCurrentKey(null);
      }
    },
    setDefaultNodeByTreeKey(newNodeTreeKeyList) {
      this.treeKeyList = newNodeTreeKeyList;
    },
    getCurrentNode() {
      if (this.isMultiple) {
        const currentCheckdNode = this.treeRef.getFilteredCheckedNodes();
        return currentCheckdNode.reduce((accumulator, value) => {
          if ((this.selectScope === TREE_CONST.SELECT_SCOPE.LEAF && isEmpty(value.children)) || this.selectScope === TREE_CONST.SELECT_SCOPE.ALL) {
            accumulator.nodes.push(value);
            accumulator.treeKeys.push(value.treeKey);
          }
          return accumulator;
        }, { nodes: [], treeKeys: [] });
      }
      const currentNode = this.treeRef.getCurrentNode();
      // if (!isEmpty(currentNode) && isEmpty(currentNode.children)) {
      if (!isEmpty(currentNode)) {
        return {
          nodes: [this.treeRef.getCurrentNode()],
          treeKeys: [this.treeRef.getCurrentNode().treeKey],
        };
      }
      return {
        nodes: [],
        treeKeys: [],
      };
    },
    setTreeData() {
      this.treeData = this.rscData;
    },
    setFilter(newFilterValue) {
      this.treeRef.filter(newFilterValue);
    },
    getTreeKeysInObjList(objList) {
      return objList.map((objNode) => objNode.treeKey);
    },
    expandNodeByTreeKey(treeKeys) {
      if (isEmpty(treeKeys)) {
        return;
      }
      treeKeys.forEach((treeKey) => {
        const node = this.treeRef.getNode(treeKey);
        const path = getPathNodes(node);
        path.forEach((item) => {
          if (!item.isLeaf) item.expanded = true;
        });
      });
    },
    onCheckChange() {
      const nodes = this.getCurrentNode().nodes;
      if (!this.isMultipleUnit) {
        if (!isEmpty(nodes)) {
          let isSameUnit = true;
          if (isEmpty(this.selectedNodeunit)) {
            this.selectedNodeunit = isEmpty(nodes[0].rscUnit) ? '' : nodes[0].rscUnit;
          }
          nodes.forEach((node) => {
            const newUnit = isEmpty(node.rscUnit) ? '' : node.rscUnit;
            if (this.selectedNodeunit !== newUnit) {
              this.$refs.treeRef.getNode(node.treeKey).setChecked(false);
              isSameUnit = false;
            }
          });
          if (!isSameUnit) {
            this.$message({
              message: '같은 단위의 자원만 선택할 수 있습니다.',
            });
          }
        } else {
          this.selectedNodeunit = '';
        }
      }
      this.$emit('update:selectedNode', this.getCurrentNode());
      // if (isChecked) {
      //   const nodes = this.getCurrentNode().nodes;
      //   if (!this.isMultipleUnit) {
      //     console.log('!isEmpty(nodes)', !isEmpty(nodes));
      //     if (!isEmpty(nodes)) {
      //       let isSameUnit = true;
      //       if (isEmpty(this.selectedNodeunit)) {
      //         this.selectedNodeunit = isEmpty(nodes[0].rscUnit) ? '' : nodes[0].rscUnit;
      //       }
      //       nodes.forEach((node) => {
      //         const newUnit = isEmpty(node.rscUnit) ? '' : node.rscUnit;
      //         if (this.selectedNodeunit !== newUnit) {
      //           this.$refs.treeRef.getNode(node.treeKey).setChecked(false);
      //           isSameUnit = false;
      //         }
      //       });
      //       if (!isSameUnit) {
      //         this.$message({
      //           message: '같은 단위의 자원만 선택할 수 있습니다.',
      //         });
      //       }
      //     } else {
      //       this.selectedNodeunit = '';
      //     }
      //   }
      //   this.$emit('update:selectedNode', this.getCurrentNode());
      // }
    },
    onNodeClick(clickedNode) {
      const nodes = clickedNode.children ? [] : [clickedNode];
      const treeKeys = clickedNode.children ? [] : [clickedNode.treeKey];
      const resultNode = {
        nodes,
        treeKeys,
      };
      // const resultNode = clickedNode.children ? [] : [clickedNode.treeKey];
      this.$emit('update:selectedNode', resultNode);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/coord/setting/components/RscSelectTree.vue